import { useQueryClient } from '@tanstack/react-query';
import { Modal } from 'antd';
import { useAccorderenTerugdraaien } from 'components/headers/menu/model/accorderen';
import { Spinal } from 'components/spinal/Spinal';
import { refreshCallContext } from 'helpers/queries/call-context';
import { useState } from 'react';

export const useHeropenenModal = () => {
  const [visible, setVisible] = useState(false);
  const queryClient = useQueryClient();
  const heropenen = useAccorderenTerugdraaien();
  const component = (
    <Modal
      title="Heropenen KringloopWijzer"
      open={visible}
      onOk={e =>
        heropenen.mutate(null, {
          onSuccess() {
            setVisible(false);
            void refreshCallContext(queryClient);
            e.stopPropagation();
          },
          onError() {
            setVisible(false);
            e.stopPropagation();
          },
        })
      }
      onCancel={e => {
        setVisible(false);
        e.stopPropagation();
      }}
      okText="Ja"
      cancelText="Annuleer"
      okButtonProps={{
        style: { backgroundColor: '#00A1DF', borderColor: '#00A1DF' },
        disabled: heropenen.isPending,
      }}
      cancelButtonProps={{
        style: { backgroundColor: '#6e7881', borderColor: '#6e7881', color: '#fff' },
        disabled: heropenen.isPending,
      }}
      width={750}
      maskClosable={!heropenen.isPending}
      closable={!heropenen.isPending}>
      <Spinal loading={heropenen.isPending} initializing={false}>
        <p>
          U wijzigt de status van uw KringloopWijzer naar Concept. Daardoor worden alle automatische leverberichten die eventueel voor u ontvangen zijn terwijl
          de Status Ingediend of Definitief Goedgekeurd was, alsnog in uw KringloopWijzer verwerkt. Controleer uw KringloopWijzer voor u hem opnieuw indient.
        </p>
        <b>Wilt u doorgaan met het heropenen van deze KringloopWijzer?</b>
      </Spinal>
    </Modal>
  );
  return { heropenenModal: component, isPending: heropenen.isPending, openModal: () => setVisible(true) };
};
